import { mapState } from 'vuex';

const ALL = {
  per_page: 99999,
};

const kinds = [
  'domains',
  'domainsWeb',
  'banks',
  'banksWeb',
  'stores',
  'sellers',
  'vehicleModels',
  'returnDomains',
  'vehicleDomains',
  'vehicleFilters',
];

export default {
  computed: {
    ...mapState([
      ...kinds,
    ]),
  },
  methods: {
    preloadExpired(kind, cached, payload) {
      const {
        datetime,
        filters,
        items,
      } = this[kind].list;

      if (!cached || !datetime) {
        return true;
      }

      if (((new Date()) - datetime) > 60 * 60 * 1000) {
        return true;
      }

      if (JSON.stringify(filters) !== JSON.stringify(payload)) {
        return true;
      }

      return !Object.keys(items).length;
    },

    preloadKind(kind, cached, payload) {
      if (this.preloadExpired(kind, cached, payload)) {
        this.$store.dispatch(`${kind}/filter`, {
          ...payload,
        });

        return this.$store.dispatch(`${kind}/list`, {
          ...ALL,
          ...payload,
        });
      }

      return Promise.resolve();
    },

    ...kinds.reduce((state, item) => {
      const key = item.charAt(0).toUpperCase() + item.substr(1);

      state[`preload${key}`] = function preloader(cached = true, payload = {}) {
        return this.preloadKind(item, cached, payload);
      };

      return state;
    }, {}),
  },
};
